import type { CSSProperties, ReactNode } from 'react';

import { Card, CardBody, cn } from '@heroui/react';

interface Props {
  className?: string;
  description?: ReactNode;
  icon?: ReactNode;
  size?: 'lg' | 'md' | 'sm';
  style?: CSSProperties;
  title: ReactNode;
}

const sizeMap = {
  lg: '75dvh',
  md: '45dvh',
  sm: '15dvh',
};

export function EmptyCard({
  className = '',
  description = '',
  icon = undefined,
  size = 'lg',
  style = {},
  title,
}: Props) {
  return (
    <Card
      className={cn('w-full rounded-xl', className)}
      shadow="none"
      style={{ minHeight: sizeMap[size], ...style }}
    >
      <CardBody>
        <div className="text-default-500 text-center">
          <p
            className={cn('mt-2 text-xl font-bold', {
              'mt-8 text-2xl': size === 'lg',
            })}
          >
            {title}
          </p>
          {description && <div className="mx-auto p-3">{description}</div>}
        </div>
        {icon}
      </CardBody>
    </Card>
  );
}
